import React, { useCallback, useEffect } from "react";

import { trackEmailLink } from "services";

import { useCancelAsyncOnUnmount, useNavigate, useParams, useTranslation } from "utils";

import { MainPage } from "components";

const Tracking = () => {
  const { t } = useTranslation(["meta"]);
  const signal = useCancelAsyncOnUnmount()();
  const navigate = useNavigate();
  const { token } = useParams();

  const share = {
    title: t("meta:redirect.title"),
    summary: t("meta:redirect.description"),
    link: `${process.env.REACT_APP_FARM_URL}/sign-up`,
    image: `${process.env.REACT_APP_FARM_URL}/images/misc/share.png`,
  };

  const trackLink = useCallback(() => {
    trackEmailLink({
      token: token,
      signal,
    })
      .then((res) => {
        window.location.href = res.link;
      })
      .catch((_err) => {
        navigate("/");
      });
  }, [navigate, token, signal]);

  useEffect(() => {
    trackLink();
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  return <MainPage pageName={"sign-in-up"} share={share} loading={true}></MainPage>;
};

export default Tracking;
